export default function IconTwitter() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
			<g clipPath="url(#clip0_x_icon)">
				<path d="M1.75 1H4.25L7 5.25L9.75 1H12.25L8.25 6.5L12.5 12H9.75L7 8.25L4.25 12H1.75L5.75 6.5L1.75 1Z" fill="currentColor" />
			</g>
			<defs>
				<clipPath id="clip0_x_icon">
					<rect width="12.6" height="12.6" fill="white" transform="translate(0.7 0.1)" />
				</clipPath>
			</defs>
		</svg>
	);
}
